// Italian provinces and major cities data
export const PROVINCE_ITALIANE = [
  { sigla: 'AG', nome: 'Agrigento' },
  { sigla: 'AL', nome: 'Alessandria' },
  { sigla: 'AN', nome: 'Ancona' },
  { sigla: 'AO', nome: 'Aosta' },
  { sigla: 'AR', nome: 'Arezzo' },
  { sigla: 'AP', nome: 'Ascoli Piceno' },
  { sigla: 'AT', nome: 'Asti' },
  { sigla: 'AV', nome: 'Avellino' },
  { sigla: 'BA', nome: 'Bari' },
  { sigla: 'BT', nome: 'Barletta-Andria-Trani' },
  { sigla: 'BL', nome: 'Belluno' },
  { sigla: 'BN', nome: 'Benevento' },
  { sigla: 'BG', nome: 'Bergamo' },
  { sigla: 'BI', nome: 'Biella' },
  { sigla: 'BO', nome: 'Bologna' },
  { sigla: 'BZ', nome: 'Bolzano' },
  { sigla: 'BS', nome: 'Brescia' },
  { sigla: 'BR', nome: 'Brindisi' },
  { sigla: 'CA', nome: 'Cagliari' },
  { sigla: 'CL', nome: 'Caltanissetta' },
  { sigla: 'CB', nome: 'Campobasso' },
  { sigla: 'CE', nome: 'Caserta' },
  { sigla: 'CT', nome: 'Catania' },
  { sigla: 'CZ', nome: 'Catanzaro' },
  { sigla: 'CH', nome: 'Chieti' },
  { sigla: 'CO', nome: 'Como' },
  { sigla: 'CS', nome: 'Cosenza' },
  { sigla: 'CR', nome: 'Cremona' },
  { sigla: 'KR', nome: 'Crotone' },
  { sigla: 'CN', nome: 'Cuneo' },
  { sigla: 'EN', nome: 'Enna' },
  { sigla: 'FM', nome: 'Fermo' },
  { sigla: 'FE', nome: 'Ferrara' },
  { sigla: 'FI', nome: 'Firenze' },
  { sigla: 'FG', nome: 'Foggia' },
  { sigla: 'FC', nome: 'Forlì-Cesena' },
  { sigla: 'FR', nome: 'Frosinone' },
  { sigla: 'GE', nome: 'Genova' },
  { sigla: 'GO', nome: 'Gorizia' },
  { sigla: 'GR', nome: 'Grosseto' },
  { sigla: 'IM', nome: 'Imperia' },
  { sigla: 'IS', nome: 'Isernia' },
  { sigla: 'SP', nome: 'La Spezia' },
  { sigla: 'AQ', nome: "L'Aquila" },
  { sigla: 'LT', nome: 'Latina' },
  { sigla: 'LE', nome: 'Lecce' },
  { sigla: 'LC', nome: 'Lecco' },
  { sigla: 'LI', nome: 'Livorno' },
  { sigla: 'LO', nome: 'Lodi' },
  { sigla: 'LU', nome: 'Lucca' },
  { sigla: 'MC', nome: 'Macerata' },
  { sigla: 'MN', nome: 'Mantova' },
  { sigla: 'MS', nome: 'Massa-Carrara' },
  { sigla: 'MT', nome: 'Matera' },
  { sigla: 'ME', nome: 'Messina' },
  { sigla: 'MI', nome: 'Milano' },
  { sigla: 'MO', nome: 'Modena' },
  { sigla: 'MB', nome: 'Monza e Brianza' },
  { sigla: 'NA', nome: 'Napoli' },
  { sigla: 'NO', nome: 'Novara' },
  { sigla: 'NU', nome: 'Nuoro' },
  { sigla: 'OR', nome: 'Oristano' },
  { sigla: 'PD', nome: 'Padova' },
  { sigla: 'PA', nome: 'Palermo' },
  { sigla: 'PR', nome: 'Parma' },
  { sigla: 'PV', nome: 'Pavia' },
  { sigla: 'PG', nome: 'Perugia' },
  { sigla: 'PU', nome: 'Pesaro e Urbino' },
  { sigla: 'PE', nome: 'Pescara' },
  { sigla: 'PC', nome: 'Piacenza' },
  { sigla: 'PI', nome: 'Pisa' },
  { sigla: 'PT', nome: 'Pistoia' },
  { sigla: 'PN', nome: 'Pordenone' },
  { sigla: 'PZ', nome: 'Potenza' },
  { sigla: 'PO', nome: 'Prato' },
  { sigla: 'RG', nome: 'Ragusa' },
  { sigla: 'RA', nome: 'Ravenna' },
  { sigla: 'RC', nome: 'Reggio Calabria' },
  { sigla: 'RE', nome: 'Reggio Emilia' },
  { sigla: 'RI', nome: 'Rieti' },
  { sigla: 'RN', nome: 'Rimini' },
  { sigla: 'RM', nome: 'Roma' },
  { sigla: 'RO', nome: 'Rovigo' },
  { sigla: 'SA', nome: 'Salerno' },
  { sigla: 'SS', nome: 'Sassari' },
  { sigla: 'SV', nome: 'Savona' },
  { sigla: 'SI', nome: 'Siena' },
  { sigla: 'SR', nome: 'Siracusa' },
  { sigla: 'SO', nome: 'Sondrio' },
  { sigla: 'SU', nome: 'Sud Sardegna' },
  { sigla: 'TA', nome: 'Taranto' },
  { sigla: 'TE', nome: 'Teramo' },
  { sigla: 'TR', nome: 'Terni' },
  { sigla: 'TO', nome: 'Torino' },
  { sigla: 'TP', nome: 'Trapani' },
  { sigla: 'TN', nome: 'Trento' },
  { sigla: 'TV', nome: 'Treviso' },
  { sigla: 'TS', nome: 'Trieste' },
  { sigla: 'UD', nome: 'Udine' },
  { sigla: 'VA', nome: 'Varese' },
  { sigla: 'VE', nome: 'Venezia' },
  { sigla: 'VB', nome: 'Verbano-Cusio-Ossola' },
  { sigla: 'VC', nome: 'Vercelli' },
  { sigla: 'VR', nome: 'Verona' },
  { sigla: 'VV', nome: 'Vibo Valentia' },
  { sigla: 'VI', nome: 'Vicenza' },
  { sigla: 'VT', nome: 'Viterbo' },
];

// Major Italian cities (capoluoghi and largest cities)
export const CITTA_ITALIANE = [
  'Roma', 'Milano', 'Napoli', 'Torino', 'Palermo', 'Genova', 'Bologna', 'Firenze',
  'Bari', 'Catania', 'Venezia', 'Verona', 'Messina', 'Padova', 'Trieste', 'Taranto',
  'Brescia', 'Parma', 'Prato', 'Modena', 'Reggio Calabria', 'Reggio Emilia',
  'Perugia', 'Ravenna', 'Livorno', 'Cagliari', 'Foggia', 'Rimini', 'Salerno',
  'Ferrara', 'Sassari', 'Latina', 'Giugliano in Campania', 'Monza', 'Siracusa',
  'Pescara', 'Bergamo', 'Forlì', 'Trento', 'Vicenza', 'Terni', 'Bolzano',
  'Novara', 'Piacenza', 'Ancona', 'Andria', 'Arezzo', 'Udine', 'Cesena',
  'Lecce', 'Pesaro', 'Barletta', 'Alessandria', 'La Spezia', 'Catanzaro',
  'Pistoia', 'Brindisi', 'Como', 'Altamura', 'Pavia', 'Grosseto', 'Cosenza',
  'Potenza', 'Lucca', 'Lamezia Terme', 'Massa', 'Campobasso', 'Trapani',
  'Sanremo', 'Ragusa', 'Caltanissetta', 'Enna', 'Agrigento', 'Siena',
  'Rieti', 'Savona', 'Teramo', 'Chieti', "L'Aquila", 'Ascoli Piceno',
  'Benevento', 'Avellino', 'Caserta', 'Frosinone', 'Viterbo', 'Treviso',
  'Belluno', 'Pordenone', 'Gorizia', 'Isernia', 'Aosta', 'Cuneo', 'Asti',
  'Biella', 'Vercelli', 'Verbania', 'Lodi', 'Cremona', 'Mantova', 'Lecco',
  'Sondrio', 'Varese', 'Rovigo', 'Oristano', 'Nuoro', 'Matera', 'Crotone',
  'Vibo Valentia', 'Fermo', 'Barletta', 'Trani', 'Molfetta', 'Bitonto',
  'Cerignola', 'Manfredonia', 'San Severo', 'Lucera', 'Corato', 'Monopoli',
  'Fasano', 'Nardò', 'Galatina', 'Manduria', 'Martina Franca', 'Ostuni',
  'Corigliano-Rossano', 'Acerra', 'Afragola', 'Aversa', 'Benevento', 'Battipaglia',
  'Scafati', 'Torre del Greco', 'Castellammare di Stabia', 'Portici', 'Ercolano',
  'San Giorgio a Cremano', 'Pozzuoli', 'Casalnuovo di Napoli', 'Quarto',
  'Casoria', 'Marano di Napoli', 'Marcianise', 'Maddaloni', 'Santa Maria Capua Vetere',
  'Cava de\' Tirreni', 'Eboli', 'Nocera Inferiore', 'Pagani', 'Sarno', 'Angri',
  'Gela', 'Vittoria', 'Modica', 'Comiso', 'Sciacca', 'Licata', 'Marsala',
  'Mazara del Vallo', 'Castelvetrano', 'Alcamo', 'Bagheria', 'Carini', 'Monreale',
  'Partinico', 'Termini Imerese', 'Acireale', 'Paternò', 'Misterbianco', 'Caltagirone',
  'Giarre', 'Barcellona Pozzo di Gotto', 'Milazzo', 'Patti', 'Capo d\'Orlando',
].sort();

// ATECO codes (most common)
export const CODICI_ATECO = [
  { codice: '01.11.10', descrizione: 'Coltivazione di cereali (escluso il riso)' },
  { codice: '01.13.10', descrizione: 'Coltivazione di ortaggi (inclusi i meloni) in foglia, a fusto, a frutto, in radici, bulbi e tuberi in piena aria' },
  { codice: '01.21.00', descrizione: 'Coltivazione di uva' },
  { codice: '10.71.10', descrizione: 'Produzione di pane; prodotti di pasticceria freschi' },
  { codice: '10.86.00', descrizione: 'Produzione di preparati omogeneizzati e di alimenti dietetici' },
  { codice: '25.11.00', descrizione: 'Fabbricazione di strutture metalliche e parti assemblate di strutture' },
  { codice: '25.62.00', descrizione: 'Lavori di meccanica generale' },
  { codice: '41.20.00', descrizione: 'Costruzione di edifici residenziali e non residenziali' },
  { codice: '42.11.00', descrizione: 'Costruzione di strade, autostrade e piste aeroportuali' },
  { codice: '43.11.00', descrizione: 'Demolizione' },
  { codice: '43.21.01', descrizione: 'Installazione di impianti elettrici in edifici o in altre opere di costruzione' },
  { codice: '43.22.01', descrizione: 'Installazione di impianti idraulici, di riscaldamento e di condizionamento dell\'aria' },
  { codice: '43.29.09', descrizione: 'Altri lavori di costruzione e installazione n.c.a.' },
  { codice: '43.31.00', descrizione: 'Intonacatura' },
  { codice: '43.32.01', descrizione: 'Posa in opera di infissi, arredi, controsoffitti, pareti mobili e simili' },
  { codice: '43.33.00', descrizione: 'Rivestimento di pavimenti e di muri' },
  { codice: '43.34.00', descrizione: 'Tinteggiatura e posa in opera di vetri' },
  { codice: '43.39.01', descrizione: 'Attività non specializzate di lavori edili (muratori)' },
  { codice: '43.91.00', descrizione: 'Realizzazione di coperture' },
  { codice: '45.11.01', descrizione: 'Commercio all\'ingrosso e al dettaglio di autovetture e autoveicoli leggeri' },
  { codice: '45.20.10', descrizione: 'Riparazioni meccaniche di autoveicoli' },
  { codice: '45.20.20', descrizione: 'Riparazione di carrozzerie di autoveicoli' },
  { codice: '45.32.00', descrizione: 'Commercio al dettaglio di parti e accessori di autoveicoli' },
  { codice: '46.11.00', descrizione: 'Intermediari del commercio di materie prime agricole, di animali vivi, di materie prime tessili e di semilavorati' },
  { codice: '46.21.22', descrizione: 'Commercio all\'ingrosso di sementi e alimenti per il bestiame, fertilizzanti' },
  { codice: '46.31.10', descrizione: 'Commercio all\'ingrosso di frutta e ortaggi freschi' },
  { codice: '46.34.10', descrizione: 'Commercio all\'ingrosso di bevande alcoliche' },
  { codice: '46.36.00', descrizione: 'Commercio all\'ingrosso di zucchero, cioccolato, dolciumi e prodotti da forno' },
  { codice: '46.39.10', descrizione: 'Commercio all\'ingrosso non specializzato di prodotti alimentari, bevande e tabacco' },
  { codice: '46.41.10', descrizione: 'Commercio all\'ingrosso di tessuti' },
  { codice: '46.42.10', descrizione: 'Commercio all\'ingrosso di abbigliamento e accessori' },
  { codice: '46.43.10', descrizione: 'Commercio all\'ingrosso di elettrodomestici, di elettronica di consumo audio e video' },
  { codice: '46.44.30', descrizione: 'Commercio all\'ingrosso di saponi, detersivi e altri prodotti per la pulizia' },
  { codice: '46.49.10', descrizione: 'Commercio all\'ingrosso di carta, cartone e articoli di cartoleria' },
  { codice: '46.49.90', descrizione: 'Commercio all\'ingrosso di altri beni di consumo n.c.a.' },
  { codice: '46.52.29', descrizione: 'Commercio all\'ingrosso di altri apparecchi elettronici per telecomunicazioni e di altri componenti elettronici' },
  { codice: '46.61.00', descrizione: 'Commercio all\'ingrosso di macchine, accessori e utensili agricoli, inclusi i trattori' },
  { codice: '46.69.19', descrizione: 'Commercio all\'ingrosso di altre macchine e attrezzature per l\'industria, il commercio e la navigazione n.c.a.' },
  { codice: '46.71.00', descrizione: 'Commercio all\'ingrosso di prodotti petroliferi e lubrificanti per autotrazione, di combustibili per riscaldamento' },
  { codice: '46.72.20', descrizione: 'Commercio all\'ingrosso di ferro e acciaio' },
  { codice: '46.73.10', descrizione: 'Commercio all\'ingrosso di legname e di materiali da costruzione' },
  { codice: '46.74.10', descrizione: 'Commercio all\'ingrosso di articoli in ferro e in altri metalli' },
  { codice: '46.76.10', descrizione: 'Commercio all\'ingrosso di fibre tessili gregge e semilavorate' },
  { codice: '46.90.00', descrizione: 'Commercio all\'ingrosso non specializzato' },
  { codice: '47.11.10', descrizione: 'Ipermercati' },
  { codice: '47.11.20', descrizione: 'Supermercati' },
  { codice: '47.11.40', descrizione: 'Minimercati ed altri esercizi non specializzati di alimentari vari' },
  { codice: '47.19.10', descrizione: 'Grandi magazzini' },
  { codice: '47.19.90', descrizione: 'Empori ed altri negozi non specializzati di vari prodotti non alimentari' },
  { codice: '47.21.01', descrizione: 'Commercio al dettaglio di frutta e verdura fresca' },
  { codice: '47.21.02', descrizione: 'Commercio al dettaglio di frutta e verdura preparata e conservata' },
  { codice: '47.22.00', descrizione: 'Commercio al dettaglio di carni e di prodotti a base di carne' },
  { codice: '47.23.00', descrizione: 'Commercio al dettaglio di pesci, crostacei e molluschi' },
  { codice: '47.24.10', descrizione: 'Commercio al dettaglio di pane' },
  { codice: '47.24.20', descrizione: 'Commercio al dettaglio di torte, dolciumi, confetteria' },
  { codice: '47.25.00', descrizione: 'Commercio al dettaglio di bevande' },
  { codice: '47.26.00', descrizione: 'Commercio al dettaglio di generi di monopolio (tabaccherie)' },
  { codice: '47.29.10', descrizione: 'Commercio al dettaglio di latte e di prodotti lattiero-caseari' },
  { codice: '47.29.20', descrizione: 'Commercio al dettaglio di caffè torrefatto' },
  { codice: '47.29.90', descrizione: 'Commercio al dettaglio di altri prodotti alimentari in esercizi specializzati n.c.a.' },
  { codice: '47.41.00', descrizione: 'Commercio al dettaglio di computer, unità periferiche, software e attrezzature per ufficio' },
  { codice: '47.42.00', descrizione: 'Commercio al dettaglio di apparecchiature per le telecomunicazioni e la telefonia' },
  { codice: '47.43.00', descrizione: 'Commercio al dettaglio di apparecchi audio e video' },
  { codice: '47.51.10', descrizione: 'Commercio al dettaglio di tessuti per l\'abbigliamento, l\'arredamento e di biancheria per la casa' },
  { codice: '47.52.10', descrizione: 'Commercio al dettaglio di ferramenta, vernici, vetro piano e materiali da costruzione' },
  { codice: '47.52.20', descrizione: 'Commercio al dettaglio di articoli igienico-sanitari' },
  { codice: '47.54.00', descrizione: 'Commercio al dettaglio di elettrodomestici' },
  { codice: '47.59.10', descrizione: 'Commercio al dettaglio di mobili per la casa' },
  { codice: '47.59.91', descrizione: 'Commercio al dettaglio di articoli in legno, sughero, vimini e articoli in plastica per uso domestico' },
  { codice: '47.61.00', descrizione: 'Commercio al dettaglio di libri' },
  { codice: '47.62.10', descrizione: 'Commercio al dettaglio di giornali, riviste e periodici' },
  { codice: '47.63.00', descrizione: 'Commercio al dettaglio di registrazioni musicali e video' },
  { codice: '47.64.10', descrizione: 'Commercio al dettaglio di articoli sportivi, biciclette e articoli per il tempo libero' },
  { codice: '47.65.00', descrizione: 'Commercio al dettaglio di giochi e giocattoli (inclusi quelli elettronici)' },
  { codice: '47.71.10', descrizione: 'Commercio al dettaglio di confezioni per adulti' },
  { codice: '47.71.20', descrizione: 'Commercio al dettaglio di confezioni per bambini e neonati' },
  { codice: '47.72.10', descrizione: 'Commercio al dettaglio di calzature e accessori' },
  { codice: '47.72.20', descrizione: 'Commercio al dettaglio di articoli di pelletteria e da viaggio' },
  { codice: '47.73.10', descrizione: 'Farmacie' },
  { codice: '47.74.00', descrizione: 'Commercio al dettaglio di articoli medicali e ortopedici' },
  { codice: '47.75.10', descrizione: 'Commercio al dettaglio di articoli di profumeria, prodotti per toletta e per l\'igiene personale' },
  { codice: '47.76.10', descrizione: 'Commercio al dettaglio di fiori e piante' },
  { codice: '47.76.20', descrizione: 'Commercio al dettaglio di piccoli animali domestici' },
  { codice: '47.77.00', descrizione: 'Commercio al dettaglio di orologi, articoli di gioielleria e argenteria' },
  { codice: '47.78.10', descrizione: 'Commercio al dettaglio di mobili per ufficio' },
  { codice: '47.78.20', descrizione: 'Commercio al dettaglio di materiale per ottica e fotografia' },
  { codice: '47.78.31', descrizione: 'Commercio al dettaglio di oggetti d\'arte (incluse le gallerie d\'arte)' },
  { codice: '47.78.35', descrizione: 'Commercio al dettaglio di bomboniere' },
  { codice: '47.78.36', descrizione: 'Commercio al dettaglio di chincaglieria e bigiotteria (inclusi gli accessori di abbigliamento)' },
  { codice: '47.78.40', descrizione: 'Commercio al dettaglio di combustibile per uso domestico e per riscaldamento' },
  { codice: '47.78.50', descrizione: 'Commercio al dettaglio di armi e munizioni, articoli militari' },
  { codice: '47.78.91', descrizione: 'Commercio al dettaglio di filatelia, numismatica e articoli da collezionismo' },
  { codice: '47.78.92', descrizione: 'Commercio al dettaglio di spaghi, cordami, tele e sacchi di juta e prodotti per l\'imballaggio' },
  { codice: '47.78.99', descrizione: 'Commercio al dettaglio di altri prodotti non alimentari n.c.a.' },
  { codice: '47.79.10', descrizione: 'Commercio al dettaglio di libri di seconda mano' },
  { codice: '47.79.20', descrizione: 'Commercio al dettaglio di mobili usati e oggetti di antiquariato' },
  { codice: '47.79.30', descrizione: 'Commercio al dettaglio di indumenti e altri oggetti usati' },
  { codice: '47.81.01', descrizione: 'Commercio al dettaglio ambulante di prodotti ortofrutticoli' },
  { codice: '47.81.02', descrizione: 'Commercio al dettaglio ambulante di prodotti ittici' },
  { codice: '47.81.03', descrizione: 'Commercio al dettaglio ambulante di carne' },
  { codice: '47.81.09', descrizione: 'Commercio al dettaglio ambulante di altri prodotti alimentari e bevande n.c.a.' },
  { codice: '47.82.01', descrizione: 'Commercio al dettaglio ambulante di tessuti, articoli tessili per la casa, articoli di abbigliamento' },
  { codice: '47.82.02', descrizione: 'Commercio al dettaglio ambulante di calzature e pelletterie' },
  { codice: '47.89.01', descrizione: 'Commercio al dettaglio ambulante di fiori, piante, bulbi, semi e fertilizzanti' },
  { codice: '47.89.02', descrizione: 'Commercio al dettaglio ambulante di macchine, attrezzature e prodotti per l\'agricoltura; attrezzature per il giardinaggio' },
  { codice: '47.89.03', descrizione: 'Commercio al dettaglio ambulante di profumi e cosmetici; saponi, detersivi ed altri detergenti per qualsiasi uso' },
  { codice: '47.89.04', descrizione: 'Commercio al dettaglio ambulante di chincaglieria e bigiotteria' },
  { codice: '47.89.05', descrizione: 'Commercio al dettaglio ambulante di arredamenti per giardino; mobili; tappeti e stuoie; articoli casalinghi; elettrodomestici; materiale elettrico' },
  { codice: '47.89.09', descrizione: 'Commercio al dettaglio ambulante di altri prodotti n.c.a.' },
  { codice: '47.91.10', descrizione: 'Commercio al dettaglio di qualsiasi tipo di prodotto effettuato via internet' },
  { codice: '47.99.10', descrizione: 'Commercio al dettaglio di prodotti vari, mediante l\'intervento di un dimostratore o di un incaricato alla vendita (porta a porta)' },
  { codice: '49.31.00', descrizione: 'Trasporto terrestre di passeggeri in aree urbane e suburbane' },
  { codice: '49.32.10', descrizione: 'Trasporto con taxi' },
  { codice: '49.41.00', descrizione: 'Trasporto di merci su strada' },
  { codice: '52.10.10', descrizione: 'Magazzini di custodia e deposito per conto terzi' },
  { codice: '52.21.40', descrizione: 'Gestione di parcheggi e autorimesse' },
  { codice: '52.24.10', descrizione: 'Movimento merci relativo a trasporti aerei' },
  { codice: '52.29.10', descrizione: 'Spedizionieri e agenzie di operazioni doganali' },
  { codice: '52.29.21', descrizione: 'Intermediari dei trasporti' },
  { codice: '55.10.00', descrizione: 'Alberghi' },
  { codice: '55.20.10', descrizione: 'Villaggi turistici' },
  { codice: '55.20.20', descrizione: 'Ostelli della gioventù' },
  { codice: '55.20.30', descrizione: 'Rifugi di montagna' },
  { codice: '55.20.40', descrizione: 'Colonie marine e montane' },
  { codice: '55.20.51', descrizione: 'Affittacamere per brevi soggiorni, case ed appartamenti per vacanze, bed and breakfast, residence' },
  { codice: '55.20.52', descrizione: 'Attività di alloggio connesse alle aziende agricole' },
  { codice: '55.30.00', descrizione: 'Aree di campeggio e aree attrezzate per camper e roulotte' },
  { codice: '55.90.20', descrizione: 'Alloggi per studenti e lavoratori con servizi accessori di tipo alberghiero' },
  { codice: '56.10.11', descrizione: 'Ristorazione con somministrazione' },
  { codice: '56.10.12', descrizione: 'Attività di ristorazione connesse alle aziende agricole' },
  { codice: '56.10.20', descrizione: 'Ristorazione senza somministrazione con preparazione di cibi da asporto' },
  { codice: '56.10.30', descrizione: 'Gelaterie e pasticcerie' },
  { codice: '56.10.41', descrizione: 'Gelaterie e pasticcerie ambulanti' },
  { codice: '56.10.42', descrizione: 'Ristorazione ambulante' },
  { codice: '56.10.50', descrizione: 'Ristorazione su treni e navi' },
  { codice: '56.21.00', descrizione: 'Catering per eventi, banqueting' },
  { codice: '56.29.10', descrizione: 'Mense' },
  { codice: '56.29.20', descrizione: 'Catering continuativo su base contrattuale' },
  { codice: '56.30.00', descrizione: 'Bar e altri esercizi simili senza cucina' },
  { codice: '62.01.00', descrizione: 'Produzione di software non connesso all\'edizione' },
  { codice: '62.02.00', descrizione: 'Consulenza nel settore delle tecnologie dell\'informatica' },
  { codice: '62.03.00', descrizione: 'Gestione di strutture e apparecchiature informatiche (facility management)' },
  { codice: '62.09.09', descrizione: 'Altre attività dei servizi connessi alle tecnologie dell\'informatica n.c.a.' },
  { codice: '63.11.11', descrizione: 'Elaborazione elettronica di dati contabili (esclusi i Centri di assistenza fiscale - Loss)' },
  { codice: '63.11.19', descrizione: 'Altre elaborazioni elettroniche di dati' },
  { codice: '63.11.20', descrizione: 'Gestione database (attività delle banche dati)' },
  { codice: '63.11.30', descrizione: 'Hosting e fornitura di servizi applicativi (ASP)' },
  { codice: '63.12.00', descrizione: 'Portali web' },
  { codice: '63.91.00', descrizione: 'Attività delle agenzie di stampa' },
  { codice: '64.91.00', descrizione: 'Leasing finanziario' },
  { codice: '64.92.01', descrizione: 'Attività dei consorzi di garanzia collettiva fidi' },
  { codice: '64.92.09', descrizione: 'Altre attività creditizie n.c.a.' },
  { codice: '68.10.00', descrizione: 'Compravendita di beni immobili effettuata su beni propri' },
  { codice: '68.20.01', descrizione: 'Locazione immobiliare di beni propri o in leasing (affitto)' },
  { codice: '68.20.02', descrizione: 'Affitto di aziende' },
  { codice: '68.31.00', descrizione: 'Attività di mediazione immobiliare' },
  { codice: '68.32.00', descrizione: 'Amministrazione di condomini e gestione di beni immobili per conto terzi' },
  { codice: '69.10.10', descrizione: 'Attività degli studi legali' },
  { codice: '69.20.11', descrizione: 'Servizi forniti da dottori commercialisti' },
  { codice: '69.20.12', descrizione: 'Servizi forniti da ragionieri e periti commerciali' },
  { codice: '69.20.13', descrizione: 'Servizi forniti da revisori contabili, periti, consulenti ed altri soggetti che svolgono attività in materia di amministrazione, contabilità e tributi' },
  { codice: '69.20.30', descrizione: 'Attività dei consulenti del lavoro' },
  { codice: '70.10.00', descrizione: 'Attività delle holding impegnate nelle attività gestionali (holding operative)' },
  { codice: '70.21.00', descrizione: 'Pubbliche relazioni e comunicazione' },
  { codice: '70.22.01', descrizione: 'Attività di consulenza per la gestione della logistica aziendale' },
  { codice: '70.22.09', descrizione: 'Altre attività di consulenza imprenditoriale e altra consulenza amministrativo-gestionale e pianificazione aziendale' },
  { codice: '71.11.00', descrizione: 'Attività degli studi di architettura' },
  { codice: '71.12.10', descrizione: 'Attività degli studi di ingegneria' },
  { codice: '71.12.20', descrizione: 'Servizi di progettazione di ingegneria integrata' },
  { codice: '71.12.30', descrizione: 'Attività tecniche svolte da geometri' },
  { codice: '71.12.40', descrizione: 'Attività di cartografia e aerofotogrammetria' },
  { codice: '71.12.50', descrizione: 'Attività di studio geologico e di prospezione geognostica e mineraria' },
  { codice: '71.20.10', descrizione: 'Collaudi e analisi tecniche di prodotti' },
  { codice: '71.20.21', descrizione: 'Controllo di qualità e certificazione di prodotti, processi e sistemi' },
  { codice: '72.11.00', descrizione: 'Ricerca e sviluppo sperimentale nel campo delle biotecnologie' },
  { codice: '72.19.09', descrizione: 'Ricerca e sviluppo sperimentale nel campo delle altre scienze naturali e dell\'ingegneria n.c.a.' },
  { codice: '73.11.01', descrizione: 'Ideazione di campagne pubblicitarie' },
  { codice: '73.11.02', descrizione: 'Conduzione di campagne di marketing e altri servizi pubblicitari' },
  { codice: '73.12.00', descrizione: 'Attività delle concessionarie e degli altri intermediari di servizi pubblicitari' },
  { codice: '73.20.00', descrizione: 'Ricerche di mercato e sondaggi di opinione' },
  { codice: '74.10.10', descrizione: 'Attività di design di moda e design industriale' },
  { codice: '74.10.21', descrizione: 'Attività dei disegnatori grafici di pagine web' },
  { codice: '74.10.29', descrizione: 'Altre attività dei disegnatori grafici' },
  { codice: '74.10.30', descrizione: 'Attività dei disegnatori tecnici' },
  { codice: '74.10.90', descrizione: 'Altre attività di design' },
  { codice: '74.20.11', descrizione: 'Attività di riprese fotografiche' },
  { codice: '74.20.12', descrizione: 'Attività di riprese aeree nel campo della fotografia' },
  { codice: '74.20.19', descrizione: 'Altre attività di riprese fotografiche' },
  { codice: '74.20.20', descrizione: 'Laboratori fotografici per lo sviluppo e la stampa' },
  { codice: '74.30.00', descrizione: 'Traduzione e interpretariato' },
  { codice: '74.90.11', descrizione: 'Attività di agenti e rappresentanti di artisti ed atleti' },
  { codice: '74.90.12', descrizione: 'Attività di agenti e procuratori per lo spettacolo e lo sport' },
  { codice: '74.90.91', descrizione: 'Attività tecniche svolte da periti industriali' },
  { codice: '74.90.92', descrizione: 'Attività di consulenza agraria' },
  { codice: '74.90.93', descrizione: 'Altre attività di consulenza tecnica n.c.a.' },
  { codice: '74.90.94', descrizione: 'Attività peritali diverse dalla valutazione dei danni e dei rischi' },
  { codice: '74.90.99', descrizione: 'Altre attività professionali n.c.a.' },
  { codice: '77.11.00', descrizione: 'Noleggio di autovetture ed autoveicoli leggeri' },
  { codice: '77.12.00', descrizione: 'Noleggio di autocarri e di altri veicoli pesanti' },
  { codice: '77.21.01', descrizione: 'Noleggio di biciclette' },
  { codice: '77.21.02', descrizione: 'Noleggio senza equipaggio di imbarcazioni da diporto' },
  { codice: '77.21.09', descrizione: 'Noleggio di altre attrezzature sportive e ricreative' },
  { codice: '77.22.00', descrizione: 'Noleggio di videocassette, cd, dvd e dischi contenenti audiovisivi o videogiochi' },
  { codice: '77.29.10', descrizione: 'Noleggio di biancheria da tavola, da letto, da bagno e di articoli di vestiario' },
  { codice: '77.29.90', descrizione: 'Noleggio di altri beni per uso personale e domestico n.c.a.' },
  { codice: '77.31.00', descrizione: 'Noleggio di macchine e attrezzature agricole' },
  { codice: '77.32.00', descrizione: 'Noleggio di macchine e attrezzature per lavori edili e di genio civile' },
  { codice: '77.33.00', descrizione: 'Noleggio di macchine e attrezzature per ufficio (inclusi i computer)' },
  { codice: '77.34.00', descrizione: 'Noleggio di mezzi di trasporto marittimo e fluviale' },
  { codice: '77.35.00', descrizione: 'Noleggio di mezzi di trasporto aereo' },
  { codice: '77.39.10', descrizione: 'Noleggio di altri macchinari, attrezzature e beni materiali n.c.a.' },
  { codice: '77.39.91', descrizione: 'Noleggio di container marittimi' },
  { codice: '77.39.94', descrizione: 'Noleggio di strutture e attrezzature per manifestazioni e spettacoli: palchi, stand ed altre strutture simili' },
  { codice: '77.39.99', descrizione: 'Noleggio senza operatore di altre macchine ed attrezzature n.c.a.' },
  { codice: '77.40.00', descrizione: 'Concessione dei diritti di sfruttamento di proprietà intellettuale e prodotti simili (escluse le opere protette dal copyright)' },
  { codice: '78.10.00', descrizione: 'Attività di agenzie di collocamento' },
  { codice: '78.20.00', descrizione: 'Attività delle agenzie di lavoro temporaneo (interinale)' },
  { codice: '78.30.00', descrizione: 'Altre attività di fornitura e gestione di risorse umane' },
  { codice: '79.11.00', descrizione: 'Attività delle agenzie di viaggio' },
  { codice: '79.12.00', descrizione: 'Attività dei tour operator' },
  { codice: '79.90.11', descrizione: 'Servizi di biglietteria per eventi teatrali, sportivi ed altri eventi ricreativi e d\'intrattenimento' },
  { codice: '79.90.19', descrizione: 'Altri servizi di prenotazione e altre attività di assistenza turistica non svolte dalle agenzie di viaggio n.c.a.' },
  { codice: '79.90.20', descrizione: 'Attività delle guide e degli accompagnatori turistici' },
  { codice: '80.10.00', descrizione: 'Servizi di vigilanza privata' },
  { codice: '80.20.00', descrizione: 'Servizi connessi ai sistemi di vigilanza' },
  { codice: '80.30.00', descrizione: 'Servizi di investigazione privata' },
  { codice: '81.10.00', descrizione: 'Servizi integrati di gestione agli edifici' },
  { codice: '81.21.00', descrizione: 'Pulizia generale (non specializzata) di edifici' },
  { codice: '81.22.01', descrizione: 'Attività di pulizia e lavaggio di aree pubbliche, rimozione di neve e ghiaccio' },
  { codice: '81.22.02', descrizione: 'Altre attività di pulizia specializzata di edifici e di impianti e macchinari industriali' },
  { codice: '81.29.10', descrizione: 'Servizi di disinfestazione' },
  { codice: '81.29.91', descrizione: 'Pulizia e lavaggio di cisterne per trasporto e simili' },
  { codice: '81.29.99', descrizione: 'Altre attività di pulizia n.c.a.' },
  { codice: '81.30.00', descrizione: 'Cura e manutenzione del paesaggio (inclusi parchi, giardini e aiuole)' },
  { codice: '82.11.01', descrizione: 'Servizi integrati di supporto per le funzioni d\'ufficio' },
  { codice: '82.11.02', descrizione: 'Gestione di uffici temporanei, uffici residence' },
  { codice: '82.19.01', descrizione: 'Servizi di fotocopiatura, preparazione di documenti e altre attività specializzate di supporto per le funzioni d\'ufficio' },
  { codice: '82.19.09', descrizione: 'Servizi di stenotipia e dattilografia; altre attività di segreteria e servizi di supporto per le funzioni d\'ufficio n.c.a.' },
  { codice: '82.20.00', descrizione: 'Attività dei call center' },
  { codice: '82.30.00', descrizione: 'Organizzazione di convegni e fiere' },
  { codice: '82.91.10', descrizione: 'Attività di agenzie di recupero crediti' },
  { codice: '82.91.20', descrizione: 'Agenzie di informazioni commerciali' },
  { codice: '82.92.10', descrizione: 'Imballaggio e confezionamento di generi alimentari' },
  { codice: '82.92.20', descrizione: 'Imballaggio e confezionamento di generi non alimentari' },
  { codice: '82.99.10', descrizione: 'Servizi di gestione di pubblici mercati e pese pubbliche' },
  { codice: '82.99.21', descrizione: 'Agenzie di distribuzione di libri, giornali e riviste' },
  { codice: '82.99.30', descrizione: 'Servizi di redazione di indirizzi, indirizzatura, stampa, imbustamento, smistamento della corrispondenza' },
  { codice: '82.99.40', descrizione: 'Servizi di rilevazione e lettura di contatori' },
  { codice: '82.99.91', descrizione: 'Agenzie di distribuzione di prodotti vari diversi da libri, giornali e riviste' },
  { codice: '82.99.99', descrizione: 'Altri servizi di supporto alle imprese n.c.a.' },
  { codice: '85.51.00', descrizione: 'Corsi sportivi e ricreativi' },
  { codice: '85.52.01', descrizione: 'Corsi di danza' },
  { codice: '85.52.09', descrizione: 'Altra formazione culturale' },
  { codice: '85.53.00', descrizione: 'Autoscuole, scuole di pilotaggio e nautiche' },
  { codice: '85.59.10', descrizione: 'Università popolare' },
  { codice: '85.59.20', descrizione: 'Corsi di formazione e corsi di aggiornamento professionale' },
  { codice: '85.59.30', descrizione: 'Scuole e corsi di lingua' },
  { codice: '85.59.90', descrizione: 'Altri servizi di istruzione n.c.a.' },
  { codice: '85.60.01', descrizione: 'Orientamento scolastico e professionale' },
  { codice: '85.60.09', descrizione: 'Altri servizi di supporto all\'istruzione' },
  { codice: '86.10.10', descrizione: 'Ospedali e case di cura generici' },
  { codice: '86.10.20', descrizione: 'Ospedali e case di cura specialistici' },
  { codice: '86.10.30', descrizione: 'Istituti, cliniche e policlinici universitari' },
  { codice: '86.10.40', descrizione: 'Ospedali e case di cura per lunga degenza' },
  { codice: '86.21.00', descrizione: 'Servizi degli studi medici di medicina generale' },
  { codice: '86.22.01', descrizione: 'Prestazioni sanitarie svolte da chirurghi' },
  { codice: '86.22.02', descrizione: 'Studi di radiologia e diagnostica per immagini' },
  { codice: '86.22.03', descrizione: 'Studi di dialisi' },
  { codice: '86.22.04', descrizione: 'Studi di endoscopia e gastroenterologia' },
  { codice: '86.22.05', descrizione: 'Studi di cardiologia' },
  { codice: '86.22.06', descrizione: 'Studi di dermatologia' },
  { codice: '86.22.09', descrizione: 'Altri studi medici specialistici e poliambulatori' },
  { codice: '86.23.00', descrizione: 'Attività degli studi odontoiatrici' },
  { codice: '86.90.11', descrizione: 'Laboratori di analisi cliniche' },
  { codice: '86.90.12', descrizione: 'Laboratori radiografici' },
  { codice: '86.90.21', descrizione: 'Fisioterapia' },
  { codice: '86.90.29', descrizione: 'Altre attività paramediche indipendenti n.c.a.' },
  { codice: '86.90.30', descrizione: 'Attività svolta da psicologi' },
  { codice: '86.90.41', descrizione: 'Servizi di trasporto di malati e infortunati (ambulanze)' },
  { codice: '86.90.42', descrizione: 'Servizi di banche del sangue, latteria umana, sperma, trapianto organi' },
  { codice: '87.10.00', descrizione: 'Strutture di assistenza infermieristica residenziale' },
  { codice: '87.20.00', descrizione: 'Strutture di assistenza residenziale per persone affette da ritardi mentali, disturbi mentali o che abusano di sostanze stupefacenti' },
  { codice: '87.30.00', descrizione: 'Strutture di assistenza residenziale per anziani e disabili' },
  { codice: '87.90.00', descrizione: 'Altre strutture di assistenza sociale residenziale' },
  { codice: '88.10.00', descrizione: 'Assistenza sociale non residenziale per anziani e disabili' },
  { codice: '88.91.00', descrizione: 'Servizi di asili nido e assistenza diurna per minori disabili' },
  { codice: '88.99.00', descrizione: 'Altre attività di assistenza sociale non residenziale n.c.a.' },
  { codice: '90.01.01', descrizione: 'Attività nel campo della recitazione' },
  { codice: '90.01.09', descrizione: 'Altre rappresentazioni artistiche' },
  { codice: '90.02.01', descrizione: 'Noleggio con operatore di strutture ed attrezzature per manifestazioni e spettacoli' },
  { codice: '90.02.02', descrizione: 'Attività nel campo della regia' },
  { codice: '90.02.09', descrizione: 'Altre attività di supporto alle rappresentazioni artistiche' },
  { codice: '90.03.01', descrizione: 'Attività dei giornalisti indipendenti' },
  { codice: '90.03.02', descrizione: 'Attività di conservazione e restauro di opere d\'arte' },
  { codice: '90.03.09', descrizione: 'Altre creazioni artistiche e letterarie' },
  { codice: '90.04.00', descrizione: 'Gestione di teatri, sale da concerto e altre strutture artistiche' },
  { codice: '91.01.00', descrizione: 'Attività di biblioteche ed archivi' },
  { codice: '91.02.00', descrizione: 'Attività di musei' },
  { codice: '91.03.00', descrizione: 'Gestione di luoghi e monumenti storici e attrazioni simili' },
  { codice: '91.04.00', descrizione: 'Attività degli orti botanici, dei giardini zoologici e delle riserve naturali' },
  { codice: '93.11.10', descrizione: 'Gestione di stadi' },
  { codice: '93.11.20', descrizione: 'Gestione di piscine' },
  { codice: '93.11.30', descrizione: 'Gestione di impianti sportivi polivalenti' },
  { codice: '93.11.90', descrizione: 'Gestione di altri impianti sportivi n.c.a.' },
  { codice: '93.12.00', descrizione: 'Attività di club sportivi' },
  { codice: '93.13.00', descrizione: 'Gestione di palestre' },
  { codice: '93.19.10', descrizione: 'Enti e organizzazioni sportive, promozione di eventi sportivi' },
  { codice: '93.19.91', descrizione: 'Ricarica di bombole per attività subacquee' },
  { codice: '93.19.92', descrizione: 'Attività delle guide alpine' },
  { codice: '93.19.99', descrizione: 'Altre attività sportive n.c.a.' },
  { codice: '93.21.00', descrizione: 'Parchi di divertimento e parchi tematici' },
  { codice: '93.29.10', descrizione: 'Discoteche, sale da ballo night-club e simili' },
  { codice: '93.29.20', descrizione: 'Gestione di stabilimenti balneari: marittimi, lacuali e fluviali' },
  { codice: '93.29.30', descrizione: 'Sale giochi e biliardi' },
  { codice: '93.29.90', descrizione: 'Altre attività di intrattenimento e di divertimento n.c.a.' },
  { codice: '94.11.00', descrizione: 'Attività di organizzazioni economiche e di datori di lavoro' },
  { codice: '94.12.10', descrizione: 'Attività di federazioni e ordini professionali' },
  { codice: '94.12.20', descrizione: 'Attività di associazioni professionali' },
  { codice: '94.20.00', descrizione: 'Attività dei sindacati di lavoratori dipendenti' },
  { codice: '94.91.00', descrizione: 'Attività delle organizzazioni religiose' },
  { codice: '94.92.00', descrizione: 'Attività dei partiti e delle associazioni politiche' },
  { codice: '94.99.10', descrizione: 'Attività di organizzazioni per la tutela degli interessi e dei diritti dei cittadini' },
  { codice: '94.99.20', descrizione: 'Attività di organizzazioni che perseguono fini culturali, ricreativi e la coltivazione di hobby' },
  { codice: '94.99.90', descrizione: 'Attività di altre organizzazioni associative n.c.a.' },
  { codice: '95.11.00', descrizione: 'Riparazione e manutenzione di computer e periferiche' },
  { codice: '95.12.01', descrizione: 'Riparazione e manutenzione di telefoni fissi, cordless e cellulari' },
  { codice: '95.12.09', descrizione: 'Riparazione e manutenzione di altre apparecchiature per le comunicazioni' },
  { codice: '95.21.00', descrizione: 'Riparazione di prodotti elettronici di consumo audio e video' },
  { codice: '95.22.01', descrizione: 'Riparazione di elettrodomestici e di articoli per la casa' },
  { codice: '95.22.02', descrizione: 'Riparazione di apparecchi per la riproduzione e la registrazione audio e video' },
  { codice: '95.23.00', descrizione: 'Riparazione di calzature e articoli da viaggio in pelle, cuoio o in altri materiali simili' },
  { codice: '95.24.01', descrizione: 'Riparazione di mobili e di oggetti di arredamento; laboratori di tappezzeria' },
  { codice: '95.24.02', descrizione: 'Restauro di mobili' },
  { codice: '95.25.00', descrizione: 'Riparazione di orologi e di gioielli' },
  { codice: '95.29.01', descrizione: 'Riparazione di strumenti musicali' },
  { codice: '95.29.02', descrizione: 'Riparazione di articoli sportivi (escluse le armi sportive) e attrezzature da campeggio (incluse le biciclette)' },
  { codice: '95.29.03', descrizione: 'Modifica e riparazione di articoli di abbigliamento e altri articoli tessili' },
  { codice: '95.29.04', descrizione: 'Riparazione di libri' },
  { codice: '95.29.09', descrizione: 'Riparazione di altri beni di consumo per uso personale e per la casa n.c.a.' },
  { codice: '96.01.10', descrizione: 'Attività delle lavanderie industriali' },
  { codice: '96.01.20', descrizione: 'Altre lavanderie, tintorie' },
  { codice: '96.02.01', descrizione: 'Servizi dei saloni di barbiere e parrucchiere' },
  { codice: '96.02.02', descrizione: 'Servizi degli istituti di bellezza' },
  { codice: '96.02.03', descrizione: 'Servizi di manicure e pedicure' },
  { codice: '96.03.00', descrizione: 'Servizi di pompe funebri e attività connesse' },
  { codice: '96.04.10', descrizione: 'Servizi di centri per il benessere fisico (esclusi gli stabilimenti termali)' },
  { codice: '96.04.20', descrizione: 'Stabilimenti termali' },
  { codice: '96.09.01', descrizione: 'Attività di tatuaggio e piercing' },
  { codice: '96.09.02', descrizione: 'Attività di servizi per animali da compagnia (esclusi i servizi veterinari)' },
  { codice: '96.09.03', descrizione: 'Agenzie matrimoniali e d\'incontro' },
  { codice: '96.09.04', descrizione: 'Servizi di cura degli animali da compagnia (esclusi i servizi veterinari)' },
  { codice: '96.09.05', descrizione: 'Organizzazione di feste e cerimonie' },
  { codice: '96.09.09', descrizione: 'Altre attività di servizi per la persona n.c.a.' },
];

// Forme giuridiche comuni
export const FORME_GIURIDICHE = [
  'S.R.L. - Società a Responsabilità Limitata',
  'S.R.L.S. - Società a Responsabilità Limitata Semplificata',
  'S.P.A. - Società per Azioni',
  'S.A.P.A. - Società in Accomandita per Azioni',
  'S.N.C. - Società in Nome Collettivo',
  'S.A.S. - Società in Accomandita Semplice',
  'S.S. - Società Semplice',
  'Ditta Individuale',
  'Impresa Familiare',
  'Cooperativa',
  'Consorzio',
  'Associazione',
  'Fondazione',
  'Ente Pubblico',
];
